import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { IoMdClose } from 'react-icons/io';
import { FaPlay } from 'react-icons/fa';
const RedemptionVideoModal = ({ show, onClose, autoPlay }) => {
  const [isPlaying, setIsPlaying] = useState(autoPlay);


  useEffect(() => {
    if (autoPlay) {
      console.log('Analytics: video_played_auto');
    } else if (show) {
      console.log('Analytics: video_played_manual');
    }
  }, [show, autoPlay]);

  const handlePlayClick = () => {
    setIsPlaying(true);
    console.log('Analytics: video_played_manual');
  };

  const handleSkip = () => {
    console.log('Analytics: video_skipped');
    onClose();
  };

  const handleVideoEnd = () => {
    console.log('Analytics: video_completed');
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg" className="redemption-modal" id="CI-details">
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <div className="position-relative pb-2">
          <h4 className="mb-2 font-weight-bolder">How to Redeem Your Coupon</h4>
          <p className="mb-3 font-weight-bold">Watch this quick video to learn how to redeem your coupon step-by-step.</p>

          <div className="video-container mb-3" style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden' }}>
          {isPlaying ? (
            <video
              src="https://tinyurl.com/25zgfqpu"
              autoPlay
              controls
              onEnded={handleVideoEnd}
              style={{ width: '100%', height: 'auto' }}
            />
          ) : (
            <div
              className="preview-wrapper"
              style={{
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={handlePlayClick}
            >
              <img
                src="https://pc-prod-public.s3.ap-south-1.amazonaws.com/mcoupon_redemption_thumbnail.jpg"
                alt="Video preview"
                style={{ width: '100%', display: 'block' }}
              />
              <div
                className="play-button-overlay"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: '#137FC4',
                  borderRadius: '50%',
                  padding: '20px',
                }}
              >
                <FaPlay size={24} color="#fff" />
              </div>
            </div>
          )}
        </div>

          <p className="text-muted mb-3">Already know the process? Click ‘Skip Video’ to continue directly.</p>
            <div className="d-flex justify-content-center">
              <button onClick={handleSkip} className="btn btn-primary w-10 skip-video">SKIP VIDEO</button>
            </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RedemptionVideoModal;
